import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const Hero = ({ onStart }) => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="hero-section"
      className="relative flex min-h-[var(--vph)] flex-col items-center justify-center overflow-hidden px-6 text-center"
    >
      {/* soft radial glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[70vh] w-[70vh] -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-500/10 blur-[120px]" />
      </div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="mb-5 text-sm uppercase tracking-[0.5em] text-amber-300/90 md:text-base"
        data-testid="hero-eyebrow"
      >
        {t.hero.small}
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, delay: 0.4 }}
        className="font-display text-6xl leading-[0.95] text-white sm:text-7xl md:text-8xl lg:text-[9rem]"
        data-testid="hero-title"
      >
        {t.hero.title}
      </motion.h1>

      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        onClick={onStart}
        data-testid="start-scrolling-btn"
        className="group mt-14 flex flex-col items-center gap-3"
      >
        <span className="rounded-full border border-amber-200/30 bg-white/5 px-7 py-3 text-sm tracking-[0.2em] text-amber-50 backdrop-blur-md transition-all group-hover:border-amber-200/70 group-hover:bg-white/10">
          {t.hero.scroll}
        </span>
        <ChevronDown className="h-5 w-5 animate-bounce text-amber-200/80" />
      </motion.button>
    </section>
  );
};
